import { combineReducers } from '@reduxjs/toolkit'


import courseSessionPeriodReducer from './course-session-period'
import courseSessionEnrollmentsReducer from './course-session-enrollments'
import courseSessionScheduleReducer from './course-session-schedule'
import courseSessionEnrollmentReducer from './course-session-enrollment'
import courseSessionReducer from './course-session'
import courseReducer from '../scheduling/course'

const combinedReducer = combineReducers({
  
  courseSessionPeriod: courseSessionPeriodReducer,
  courseSessionsEnrollments: courseSessionEnrollmentsReducer,
  schedule: courseSessionScheduleReducer,
  courseSessionEnrollment: courseSessionEnrollmentReducer,
  courseSession: courseSessionReducer,
  course: courseReducer,
  
})

export default combinedReducer
